import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[contentHost]',
})
export class FPContentHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
